import { useQuery } from "@tanstack/react-query";
import { useIdentity } from "../../auth/useIdentity";
import { getPublicContact, type PublicContact } from "../../api/contact";

/**
 * The contact guests see in the portal footer, for the previews. Best effort:
 * no grant, no rows or an older radaccess all mean "no contact", and the preview
 * simply shows none -- exactly what the portal would.
 */
export function usePortalContact(ns: string): PublicContact | null {
  const identity = useIdentity();
  const q = useQuery({
    queryKey: ["publicContact", ns],
    enabled: Boolean(identity.token && ns),
    retry: false,
    staleTime: 60_000,
    queryFn: async () => (await getPublicContact(identity, ns)).data,
  });
  return q.data ?? null;
}
